export const Options = {
    Salutation: [
        { text: "Frau", value: "w" },
        { text: "Herr", value: "m" },
        { text: "Divers", value: "d" },
        { text: "Keine Angabe", value: "u" },
    ],
    BecomingAwareThrough: [
        { text: "Agentur für Arbeit", value: "Agentur für Arbeit" },
        { text: "anders", value: "anders" },
        { text: "Anzeige auf Jobbörsen", value: "Anzeige auf Jobbörsen" },
        { text: "Anzeiger", value: "Anzeiger" },
        { text: "Arbeitsagentur", value: "Arbeitsagentur" },
        { text: "Ausbildungsmesse", value: "Ausbildungsmesse" },
        { text: "Bewerbung an Tankstelle/Banner", value: "Bewerbung an Tankstelle/Banner" },
        { text: "ebay-Kleinanzeigen", value: "ebay-Kleinanzeigen" },
        { text: "Empfehlung Extern", value: "Empfehlung Extern" },
        { text: "Empfehlung Mitarbeitende", value: "Empfehlung Mitarbeitende" },
        { text: "Interne Stellenausschreibung", value: "Interne Stellenausschreibung" },
        { text: "Jobbörsen (stepstone, Monster, jobware)", value: "Jobbörsen (stepstone, Monster, jobware)" },
        { text: "Oest.de", value: "Oest.de" },
        { text: "Online-Stellenmarkt", value: "Online-Stellenmarkt" },
        { text: "Personalrecruiting", value: "Personalrecruiting" },
        { text: "Recruiting Social Media", value: "Recruiting Social Media" },
        { text: "Schwabo-Anzeige", value: "Schwabo-Anzeige" },
        { text: "Suchmaschinen", value: "Suchmaschinen" },
        { text: "Telefonat", value: "Telefonat" },
        { text: "Veranstaltungen in der Schule", value: "Veranstaltungen in der Schule" },
        { text: "WhatsApp", value: "WhatsApp" },
        { text: "Zeitungsanzeige", value: "Zeitungsanzeige" },
    ]
}
